export class PartnerHelper {

    static isAnschriftGrosskunde(anschriftType: string): boolean {
        return anschriftType === 'ANSCHRIFT_GROSSKUNDEN';
    }

    static isAnschriftHaus(anschriftType: string): boolean {
        return anschriftType === 'ANSCHRIFT_HAUS';
    }

    static isAnschriftPostfach(anschriftType: string): boolean {
        return anschriftType === 'ANSCHRIFT_POSTFACH';
    }

    static isAnschriftAusland(anschriftType: string): boolean {
        return anschriftType === 'ANSCHRIFT_AUSLAND';
    }

    static isAnschriftAuslandStrukturiert(anschriftType: string): boolean {
        return anschriftType === 'ANSCHRIFT_AUSLAND_STRUKTURIERT';
    }

}
